const description = `
Hos Penly er det vores mål, at gøre dig klogere på din privatøkonomi, så du får mest muligt ud af dine penge. 
`;
const title = 'Penly - Tag ejerskab over din økonomi';
export default {
    title,
    description,
    openGraph: {
        type: 'website',
        locale: 'da-DK',
        url: 'https://www.penly.dk/',
        site_name: 'Penly',
        defaultTitle: title,
        title,
        description,
        images: [{ url: 'https://penly.dk/static/gfx/content/penly-content-hero-1.jpg' }],
    },
};
